import Dialog, {
  DialogBody,
  DialogButtonRow,
  DialogCancelButton,
  DialogDestructiveButton,
} from '../Dialog';

const RemoveAccountConfirmationDialog = ({ open, onClose, onConfirm }) => {
  const handleConfirm = () => {
    onConfirm?.();
    onClose();
  };

  return (
    <Dialog
      open={open}
      closable={false}
      onClose={onClose}
      title="ÊTES-VOUS SÛR DE VOULOIR SUPPRIMER CE COMPTE ?"
      slotProps={{
        title: {
          sx: {
            marginBottom: '12px',
            textAlign: 'center',
          },
        },
      }}
      PaperProps={{ sx: { width: 400 } }}
    >
      <DialogBody>
        La suppression de votre compte désactivera uniquement l'accès à la plateforme.
      </DialogBody>
      <DialogButtonRow>
        <DialogCancelButton variant="contained" onClick={onClose}>
          ANNULER
        </DialogCancelButton>
        <DialogDestructiveButton variant="contained" onClick={handleConfirm}>
          SUPPRIMER
        </DialogDestructiveButton>
      </DialogButtonRow>
    </Dialog>
  );
};

export default RemoveAccountConfirmationDialog;
